/*
  Main 관리 (2018/06/01 정재윤)
    - 각 모듈 초기화
    - App 초기화
    - ACL 초기화
*/
import Vue from 'vue'

import '@/assets/css/vant.css'
import '@/assets/css/vue-toastification.css'
import '@/assets/css/vue-loading.css'
import '@/assets/css/footer-popup.css'
// import '@/assets/css/index.css'  StyleModule.js nrwStyleModule.js로 분리
// Import stylesheet

// mutationobserver-shim
import 'mutationobserver-shim'

// intersection-observer polyfill
import 'intersection-observer'

import 'url-search-params-polyfill'

/* external library import */
import Vant from 'vant'
import VueTouch from 'vue-touch'
import VueAppend from 'vue-append'
import VueMeta from 'vue-meta'
import vuejsStorage from 'vuejs-storage'
import { isEmpty } from 'lodash'
import commonUtils from '~fdp/utils/index.js'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import vClickOutside from 'v-click-outside'

import numeral from 'numeral'
import numFormat from 'vue-filter-number-format'
import moment from 'moment'
import VueObserveVisibility from 'vue-observe-visibility'
import VueClipboard from 'vue-clipboard2'
import VueScrollTo from 'vue-scrollto'
import Loading from 'vue-loading-overlay'

import '@vant/touch-emulator'

/* common config import */
import Codes from '@/config/code/code.json'

VueTouch.registerCustomEvent('singletap', {
  type: 'tap',
  taps: 1
})

VueTouch.registerCustomEvent('doubletap', {
  type: 'tap',
  taps: 2
})

/* external module install */
Vue.use(Vant)
Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(VueAppend)
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.use(vuejsStorage)
Vue.filter('numFormat', numFormat(numeral))
Vue.use(VueObserveVisibility)
Vue.use(VueClipboard)
Vue.use(VueScrollTo)

Vue.use(VueDOMPurifyHTML, {
  default: {
    USE_PROFILES: { html: true, svg: true, svgFilters: true }
  }
})

Vue.use(vClickOutside)
Vue.use(Loading)

Vue.filter('dateFormat', (value, sep) => {
  if (!value) return ''
  if (!sep) {
    return moment(value).format('YYYY.MM.DD')
  } else if (sep === '-') {
    return moment(value).format('YYYY-MM-DD')
  }
})
// Vue.use(slpui)

const appInit = () => {
  var rootStore = window.vue.getStore('root')

  if (isEmpty(rootStore.getters.getAppId)) {
    var appInfo = {
      title: window.vue.config.app.title,
      version: window.vue.config.app.version,
      startTime: new Date().getTime(),
      appId: commonUtils.generateUID()
    }

    window.vue.getStore('root').dispatch('UPDATE_APP_INFO', appInfo)
  }
}

// acl 초기화
const aclInit = () => {
  var aclArray = []

  var length = Object.keys(window.vue.config.acl).length
  for (var i = 0; i < length; i++) {
    var aclElement = {
      role: '',
      permissions: ''
    }
    var role = window.vue.config.role[i]
    var acl = window.vue.config.acl[role]

    aclElement.role = role
    aclElement.permissions = acl.permissions

    aclArray.push(aclElement)
  }

  window.vue.getStore('acls').dispatch('UPDATE', aclArray)
}

// msg 초기화
const msgInit = () => {
  let msg = { 'name': 'common', 'msg': Codes }
  window.vue.getStore('msg').dispatch('PUSH', msg)
}

// init
appInit()
aclInit()
msgInit()



// WEBPACK FOOTER //
// ./src/init.js